import React, { useState, useEffect } from 'react';
import '../style.sass';
import { InputTypeAndroid } from 'components/Forms/InputType';
import { ClasicSelectType } from 'components/Forms/Select';
import { useForm } from "react-hook-form";
import getShipping from 'services/getShipping';

export function DirectionCard(props) {
    const {
        setAddDirection,
        addDirection,
        nextPage,
        action,
        setLoading
    } = props

    const [shipping, setShupping] = useState({});
    const [datosDireccion, setDatosDireccion] = useState(addDirection);

    const [inputCalle, setInputCalle] = useState()
    const [inputNumExt, setInputNumExt] = useState()
    const [inputNumInt, setInputNumInt] = useState()
    const [inputCP, setInputCP] = useState()

    const [estado, setEstado] = useState()
    const [municipio, setMunicipio] = useState()
    const [ciudad, setCiudad] = useState()
    const [colonia, setColonia] = useState()

    const { register, handleSubmit, errors } = useForm({
        defaultValues: {
            calle: datosDireccion.calle,
            numExt: datosDireccion.numExt,
            numInt: datosDireccion.numInt,
            cp: datosDireccion.cp,
            estado: datosDireccion.estado,
            municipio: datosDireccion.municipio,
            ciudad: datosDireccion.ciudad,
            colonia: datosDireccion.colonia
        }
    });
    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);

    // guarda la informacion enviada en el formulario
    const sendFormDireccion = data => {
        setDatos({
            "calle": data.calle,
            "numExt": data.numExt,
            "numInt": data.numInt,
            "cp": data.cp,
            "estado": data.estado,
            "municipio": data.municipio,
            "ciudad": data.ciudad,
            "colonia": data.colonia,
        })
        SetReturnForm(true);
    };

    useEffect(() => {
        if (inputCP){
            if (inputCP.length === 5){
                getShipping({ codigoPostal: inputCP })
                .then(setShupping)
                setLoading(true)
            }
            else if(inputCP.length < 5 || inputCP.length === 0){
                setEstado('')
                setMunicipio('')
                setCiudad('')
                setColonia([])
            }
        }
    }, [inputCP])

    useEffect(() => {
        if (shipping){
            setLoading(false)
            setEstado(shipping.estado);
            setMunicipio(shipping.municipio);
            setCiudad(shipping.ciudad);
            if (shipping.colonias){
                if(shipping.colonias.length === 0){
                    setColonia([])
                }
                else if(shipping.colonias.length >= 1){
                    setColonia(shipping.colonias);
                }
            }
        }

        if (shipping){
        }
    }, [shipping])

    // al recibir data del formulario se guarda en variable datos bancarios
    useEffect(() => {
        if (returnForm) {
            setDatosDireccion(datos);
            setAddDirection(datos)
            SetReturnForm(false)
            nextPage()
        }
    }, [returnForm])

    const valCalle = {
        required: 'Campo obligatorio',
    };
    const valNumExt = {
        required: 'Campo obligatorio',
    };
    const valNumInt = {
    };
    const valCp = {
        required: 'Campo obligatorio',
        minLength: {
            value: 5,
            message: 'Faltan dígitos. Deben ser 5 dígitos'
        },
        maxLength: {
            value: 5,
            message: 'No debe contener más de 5 dígitos'
        },
        pattern: {
            value: /[0-9]{0,99999}/,
            message: 'El formato de CP es inválido'
        }
    };
    const valEdo = {
        required: 'Campo obligatorio',
    };
    const valMunicipio = {
        required: 'Campo obligatorio',
    };
    const valCiudad = {
        required: 'Campo obligatorio',
    };
    const valCol = {
        required: 'La Colonia es requerida',
        minLength: {
            value: 1,
            message: 'El estado es requerido'
        },
        maxLength: {
            value: 120,
            message: 'La colonia debe tener un máximo de 120 caracteres'
        }
    };

    return (
        <div className="contenedorGeneral">
            <div className="boxDireccion">
                <div className="copyDireccion">
                    <p>Ingresa la dirección que aparece en el estado de cuenta de tu tarjeta.</p>
                </div>

                <form className="formDireccion" onSubmit={handleSubmit(sendFormDireccion)} >
                    <InputTypeAndroid
                        type="text"
                        name="calle"
                        id="calle"
                        placeholder="Calle"
                        refs={register(valCalle)}
                        autocomplete='calle'
                        setNumero={setInputCalle}
                        value={inputCalle}
                        errorMessage={errors.calle && errors.calle.message}
                        pattern={'textOnly'}
                    />

                    <div className="groupNumbers">
                        <InputTypeAndroid
                            type="text"
                            name="numExt"
                            id="numExt"
                            placeholder="Número exterior"
                            className="w25"
                            refs={register(valNumExt)}
                            autocomplete='numExt'
                            setNumero={setInputNumExt}
                            value={inputNumExt}
                            errorMessage={errors.numExt && errors.numExt.message}
                            pattern={'number'}
                        />

                        <InputTypeAndroid
                            type="text"
                            name="numInt"
                            id="numInt"
                            placeholder="Número interior"
                            className="w25"
                            autocomplete='numInt'
                            refs={register(valNumInt)}
                            errorMessage={errors.numInt && errors.numInt.message}
                            setNumero={setInputNumInt}
                            value={inputNumInt}
                            pattern={'number'}
                        />
                    </div>

                    <InputTypeAndroid
                        type="text"
                        name="cp"
                        id="cp"
                        placeholder="Código postal"
                        className="w25"
                        autocomplete='cp'
                        setNumero={setInputCP}
                        value={inputCP}
                        refs={register(valCp)}
                        errorMessage={errors.cp && errors.cp.message}
                        pattern={'number'}
                        maxLength={5}
                    />

                    <InputTypeAndroid
                        type="text"
                        name="estado"
                        id="estado"
                        value={estado}
                        refs={register(valEdo)}
                        errorMessage={errors.estado && errors.estado.message}
                        readonly="readonly"
                        placeholder="Estado"
                        autocomplete='estado'
                    />

                    <InputTypeAndroid
                        type="text"
                        name="municipio"
                        id="municipio"
                        value={municipio}
                        refs={register(valMunicipio)}
                        errorMessage={errors.municipio && errors.municipio.message}
                        readonly="readonly"
                        placeholder="Alcaldía / Municipio"
                        autocomplete='municipio'
                        />

                    <InputTypeAndroid
                        type="text"
                        name="ciudad"
                        id="ciudad"
                        value={ciudad}
                        refs={register(valCiudad)}
                        errorMessage={errors.ciudad && errors.ciudad.message}
                        readonly="readonly"
                        placeholder="Ciudad"
                        autocomplete='ciudad'
                    />

                    {colonia &&
                        colonia.length >= 2
                        ?
                            <ClasicSelectType
                                type="text"
                                name="colonia"
                                id="colonia"
                                placeholder="Colonia"
                                refs={register(valCol)}
                                options={colonia}
                                errorMessage={errors.colonia && errors.colonia.message}
                            />
                        :
                            <InputTypeAndroid
                                type="text"
                                name="colonia"
                                id="colonia"
                                placeholder="Colonia"
                                refs={register(valCol)}
                                value={colonia}
                                readonly="readonly"
                                errorMessage={errors.colonia && errors.colonia.message}
                            />
                    }

                    <div className="boxBtnRealizarPago">
                        <button>Realizar pago</button>
                        <div className="btn rojo line" onClick={action} >Regresar a editar tarjeta</div>
                    </div>
                </form>
            </div>
        </div>
    )
}